import React, { useEffect, useState } from "react";
import { saasApi } from "../../api/saasApi";

function formatConsentAt(value) {
  if (!value) return "—";
  try {
    return new Date(value).toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
      timeZoneName: "short",
    });
  } catch {
    return String(value);
  }
}

export default function CompanyManagement() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedId, setExpandedId] = useState(null);

  const load = () => {
    setLoading(true);
    saasApi
      .adminCompanies("?limit=50")
      .then((res) => setItems(res.data?.items || []))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    load();
  }, []);

  const toggle = async (id, action) => {
    if (action === "suspend") await saasApi.suspendCompany(id);
    else await saasApi.activateCompany(id);
    load();
  };

  return (
    <div>
      <h1>SaaS Companies</h1>
      {loading ? (
        <p>Loading…</p>
      ) : (
        <table className="saas-compare-table">
          <thead>
            <tr>
              <th>Company</th>
              <th>Main ID</th>
              <th>Status</th>
              <th>Terms / Privacy accepted</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {items.map((c) => {
              const acceptedAt = c.terms_accepted_at || c.privacy_accepted_at;
              const isOpen = expandedId === c.id;
              return (
                <React.Fragment key={c.id}>
                  <tr>
                    <td>{c.company_name}</td>
                    <td>{c.main_id}</td>
                    <td>{c.status}</td>
                    <td>
                      {acceptedAt ? (
                        <button
                          type="button"
                          className="saas-link-btn"
                          onClick={() => setExpandedId(isOpen ? null : c.id)}
                          style={{ textAlign: "left" }}
                        >
                          {formatConsentAt(acceptedAt)}
                          {isOpen ? " ▲" : " ▼"}
                        </button>
                      ) : (
                        <span style={{ color: "#94a3b8" }}>Not recorded</span>
                      )}
                    </td>
                    <td>
                      {c.status === "suspended" ? (
                        <button
                          type="button"
                          className="saas-btn saas-btn--secondary"
                          onClick={() => toggle(c.id, "activate")}
                        >
                          Activate
                        </button>
                      ) : (
                        <button
                          type="button"
                          className="saas-btn saas-btn--secondary"
                          onClick={() => toggle(c.id, "suspend")}
                        >
                          Suspend
                        </button>
                      )}
                    </td>
                  </tr>
                  {isOpen && (
                    <tr>
                      <td colSpan={5} style={{ background: "rgba(99,102,241,0.06)", fontSize: "0.875rem" }}>
                        <div style={{ display: "grid", gap: "0.35rem", padding: "0.5rem 0" }}>
                          <div>
                            <strong>Terms accepted:</strong> {formatConsentAt(c.terms_accepted_at)}
                            {c.terms_version ? ` · version “${c.terms_version}”` : ""}
                          </div>
                          <div>
                            <strong>Privacy accepted:</strong> {formatConsentAt(c.privacy_accepted_at)}
                            {c.privacy_version ? ` · version “${c.privacy_version}”` : ""}
                          </div>
                          {c.consent_ip && (
                            <div>
                              <strong>IP:</strong> {c.consent_ip}
                            </div>
                          )}
                          {c.consent_user_agent && (
                            <div style={{ wordBreak: "break-all" }}>
                              <strong>User agent:</strong> {c.consent_user_agent}
                            </div>
                          )}
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
}
